import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribeStatus('success');
      setEmail('');
      setTimeout(() => setSubscribeStatus('idle'), 3000);
    }
  };

  return (
    <footer id="faq" className="bg-[#2C3E50] text-white py-16 mx-6 mb-6 rounded-3xl relative overflow-hidden">
      {/* Background Text Decoration */}
      <div className="absolute bottom-0 left-0 right-0 text-[#3A4F63] font-bold text-[120px] md:text-[180px] leading-none opacity-50 text-center pointer-events-none">
        いまのきもち
      </div>

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Column 1 */}
          <div>
            <h3 className="text-2xl font-bold mb-6">心と向き合う時間を</h3>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-base font-semibold mb-4">サービス</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">
                  セラピーについて
                </a>
              </li>
              <li>
                <Link to="/profile" className="hover:text-white transition-colors cursor-pointer">
                  自己紹介
                </Link>
              </li>
              <li>
                <a href="#booking" className="hover:text-white transition-colors cursor-pointer">
                  予約方法
                </a>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">
                  注意事項
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition-colors cursor-pointer">
                  よくある質問
                </Link>
              </li>
              <li>
                <Link to="/payment" className="hover:text-white transition-colors cursor-pointer">
                  お支払い方法
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <p className="text-sm text-gray-300 mb-4">最新情報をお届けします</p>
            <form onSubmit={handleSubscribe} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="メールアドレス"
                className="w-full px-4 py-3 pr-12 rounded-full bg-[#3A4F63] border border-[#4A5F73] text-white placeholder-gray-400 focus:outline-none focus:border-[#FF9B8A] text-sm"
              />
              <button
                type="submit"
                className="absolute right-1 top-1 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
                aria-label="送信"
              >
                <i className="ri-arrow-right-line text-gray-900 text-lg"></i>
              </button>
            </form>
            {subscribeStatus === 'success' && (
              <p className="text-xs text-green-400 mt-2">登録ありがとうございます!</p>
            )}
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-16 pt-8 border-t border-[#3A4F63] text-center text-sm text-gray-400">
          <p>© 2024 いまのきもち. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
        </div>
      </div>
    </footer>
  );
}
